<template>
<div v-loading="loading" class="screen-container flex-column flex-auto">
  <div v-if="myData" class="flex-column flex-auto">
    <div class="page-sub-title margin-top-20">装置检修</div>
    <div class="flex-column flex-auto padding-top-20 padding-lr-20">
      <el-row :gutter="20" type="flex" class="flex-auto">
        <el-col :span="24">
          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="column-con flex-column flex-auto">
                  <div @mouseover="tableScroll.tableMouseOver=1" @mouseout="tableScroll.tableMouseOver=0">
                    <el-table
                       v-if="myData['检修表']"
                      :data="myData['检修表']"
                      :height="$root.docHeight-190"
                      style="width: 100%">
                      <div slot="empty"><el-empty :image-size="150"></el-empty></div>
                      <el-table-column
                        label="炼厂名称"
                        prop="炼厂名称"
                        align="center"
                       
                      >
                        <template slot-scope="props">
                          **{{ props.row['炼厂名称'].substr(2) }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="检修装置类型"
                        prop="检修装置类型"
                        align="center"
                        :filters="Object.keys(dataOfFilter('检修装置类型')).map(v=>{return{text:v,value:v}})"
                        :filter-method="filterHandler"
                      >
                      </el-table-column>
                      <el-table-column
                        v-for="(item,index) in Object.keys(myData['检修表'][0]).filter(v=>{return v!='炼厂名称'&&v!='检修装置类型'})" :key="index"
                        :label="item"
                        :prop="item"
                        align="center"
                      >
                      </el-table-column>
                    </el-table>
                  </div>

              

            </div>
          </div>
          
        </el-col>

      </el-row>

    </div>
  </div>
</div>
</template>

<script>

import XLSX from 'xlsx';
export default {
  name: 'Home',
  components:{

  },
  data(){
    return {
      loading:false,
      myData:null,
      tableScroll:{
        tableMouseOver:0,
      },

    }
  },
  computed:{

    dataOfFilter(){
      return (type)=>{
        if(this.myData&&this.myData['检修表']&&this.myData['检修表'].length){
          let data = this.myData['检修表'].reduce((groups, cur) => {
            const key = cur[type];
            if (!groups[key]) {
              groups[key] = [];
            }
            groups[key].push(cur);
            return groups;
          }, {});
        
          return data
        }else{
          return null
        }
      }
      
    },

  },
  created(){
    this.getData()
  },
  methods:{
    filterHandler(value, row, column) {
        const property = column['property'];
        return row[property] === value;
      },
    scroll(element,step){
      let obj=element
      console.log(obj)
      //  obj.scrollHeight>obj.clientHeight&&(obj.innerHTML+=obj.innerHTML);
      let fun=()=>{
        if(!this.tableScroll['tableMouseOver']){
          if(obj.scrollTop%step||!this.tableScroll['tableMouseOver']){
            obj.scrollTop++
            // obj.scrollTop%=obj.scrollHeight>>1
            if(obj.scrollTop>=(obj.scrollHeight-obj.clientHeight)){
              obj.scrollTop=0
            }
          }
        }
        setTimeout(fun,obj.scrollTop%step&&obj.scrollTop<(obj.scrollHeight-obj.clientHeight-1)?10:3000)
      }
      fun()
    },
    initDivScroll(element){
      let obj=this.$refs[element]
      obj.scrollTop=0
    },
    getData(){
      this.loading=true
      this.$instance.get('/data/oil/OIL_DATA.xlsx',{
        baseURL:window.location.href.split('#')[0],
        responseType:'arraybuffer',
        headers: {
          'Content-Type': 'application/vnd.ms-excel', // 或 application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        },
      })
      .then(res=>{
        this.$message.closeAll()
        this.loading=false
        let data = new Uint8Array(res.data)
        let wb = XLSX.read(data, {type:"array"})
        let sheets = wb.Sheets // 获取文档数据
        let myData={}
        for(let key in sheets){
          myData[key]=XLSX.utils.sheet_to_json(sheets[key],{raw:false})
        }
        this.myData=myData
        this.init()
        console.log(myData)
      })
      .catch(()=> {
        this.loading=false
      }); 
    },
    init(){
      this.$nextTick(()=>{this.scroll(document.getElementsByClassName('el-table__body-wrapper')[0],48)})
      
    }
  },
  mounted(){

  },
  watch: {
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
<style scoped lang="scss">
@import './assets/css/common.scss';
</style>
